import { useState } from 'react';
import { Modal } from './Modal';

/**
 * First-login / forced password reset (AE-10884). The roster needs proof: the reset code a
 * supervisor issued, or the current password (which the login form already collected). Replaces
 * the window.prompt this used to be.
 */
export function ResetPassword({ agentId, onSubmit, onCancel, error }: {
  agentId: string;
  onSubmit: (b: { new_password: string; reset_token?: string }) => Promise<void>;
  onCancel: () => void;
  error: string | null;
}) {
  const [code, setCode] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [busy, setBusy] = useState(false);
  const mismatch = confirm.length > 0 && next !== confirm;
  const tooShort = next.length > 0 && next.length < 8;
  return (
    <Modal id="reset-password" title="Set a new password" onClose={onCancel}>
      <p>Your account for <b>{agentId}</b> needs a new password before you can log in.</p>
      <form onSubmit={async (e) => { e.preventDefault(); setBusy(true); try { await onSubmit({ new_password: next, ...(code.trim() ? { reset_token: code.trim() } : {}) }); } finally { setBusy(false); } }}>
        <div className="field"><label>Reset code (from your supervisor, if you were given one)</label><input id="reset-code" value={code} onChange={(e) => setCode(e.target.value)} autoComplete="one-time-code" /></div>
        <div className="field"><label>New password (min 8 characters)</label><input id="reset-new" type="password" value={next} onChange={(e) => setNext(e.target.value)} autoComplete="new-password" autoFocus /></div>
        <div className="field"><label>Confirm new password</label><input id="reset-confirm" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} autoComplete="new-password" /></div>
        {tooShort && <div className="error">Password must be at least 8 characters.</div>}
        {mismatch && <div className="error">Passwords do not match.</div>}
        {error && <div className="error">{error}</div>}
        <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
          <button className="primary" type="submit" disabled={busy || next.length < 8 || next !== confirm}>{busy ? 'Saving…' : 'Set password and log in'}</button>
          <button type="button" onClick={onCancel} disabled={busy}>Cancel</button>
        </div>
      </form>
    </Modal>
  );
}
